// extracted by mini-css-extract-plugin
export default {"profilePageWrapper":"Profile_profilePageWrapper__JpDH0","profilePageContentWrapper":"Profile_profilePageContentWrapper__LMooJ","buttonLogout":"Profile_buttonLogout__LCNFp"};